/**
 * Currency Utilities and Definitions
 *
 * Provides a comprehensive list of currencies with their symbols,
 * along with helper functions to retrieve, store, and format currencies.
 */

export const CURRENCY_LIST = [
  { currencyCode: "AED", currencySymbol: "AED", currencyName: "United Arab Emirates Dirham", code: "AED", symbol: "AED", name: "United Arab Emirates Dirham" },
  { currencyCode: "INR", currencySymbol: "₹", currencyName: "Indian Rupee", code: "INR", symbol: "₹", name: "Indian Rupee" },
  { currencyCode: "USD", currencySymbol: "$", currencyName: "US Dollar", code: "USD", symbol: "$", name: "US Dollar" },
  { currencyCode: "EUR", currencySymbol: "€", currencyName: "Euro", code: "EUR", symbol: "€", name: "Euro" },
  { currencyCode: "GBP", currencySymbol: "£", currencyName: "British Pound", code: "GBP", symbol: "£", name: "British Pound" },
  { currencyCode: "SAR", currencySymbol: "SAR", currencyName: "Saudi Riyal", code: "SAR", symbol: "SAR", name: "Saudi Riyal" },
  { currencyCode: "QAR", currencySymbol: "QAR", currencyName: "Qatari Riyal", code: "QAR", symbol: "QAR", name: "Qatari Riyal" },
  { currencyCode: "OMR", currencySymbol: "OMR", currencyName: "Omani Rial", code: "OMR", symbol: "OMR", name: "Omani Rial" },
  { currencyCode: "KWD", currencySymbol: "KWD", currencyName: "Kuwaiti Dinar", code: "KWD", symbol: "KWD", name: "Kuwaiti Dinar" },
  { currencyCode: "BHD", currencySymbol: "BHD", currencyName: "Bahraini Dinar", code: "BHD", symbol: "BHD", name: "Bahraini Dinar" },
  { currencyCode: "SGD", currencySymbol: "S$", currencyName: "Singapore Dollar", code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { currencyCode: "CAD", currencySymbol: "CA$", currencyName: "Canadian Dollar", code: "CAD", symbol: "CA$", name: "Canadian Dollar" },
  { currencyCode: "AUD", currencySymbol: "A$", currencyName: "Australian Dollar", code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { currencyCode: "JPY", currencySymbol: "¥", currencyName: "Japanese Yen", code: "JPY", symbol: "¥", name: "Japanese Yen" },
  { currencyCode: "CNY", currencySymbol: "¥", currencyName: "Chinese Yuan", code: "CNY", symbol: "¥", name: "Chinese Yuan" },
  { currencyCode: "NZD", currencySymbol: "NZ$", currencyName: "New Zealand Dollar", code: "NZD", symbol: "NZ$", name: "New Zealand Dollar" },
  { currencyCode: "CHF", currencySymbol: "CHF", currencyName: "Swiss Franc", code: "CHF", symbol: "CHF", name: "Swiss Franc" },
  { currencyCode: "ZAR", currencySymbol: "R", currencyName: "South African Rand", code: "ZAR", symbol: "R", name: "South African Rand" },
  { currencyCode: "MYR", currencySymbol: "RM", currencyName: "Malaysian Ringgit", code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
  { currencyCode: "THB", currencySymbol: "฿", currencyName: "Thai Baht", code: "THB", symbol: "฿", name: "Thai Baht" },
  { currencyCode: "IDR", currencySymbol: "Rp", currencyName: "Indonesian Rupiah", code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
  { currencyCode: "PHP", currencySymbol: "₱", currencyName: "Philippine Peso", code: "PHP", symbol: "₱", name: "Philippine Peso" },
  { currencyCode: "VND", currencySymbol: "₫", currencyName: "Vietnamese Dong", code: "VND", symbol: "₫", name: "Vietnamese Dong" },
  { currencyCode: "BRL", currencySymbol: "R$", currencyName: "Brazilian Real", code: "BRL", symbol: "R$", name: "Brazilian Real" },
  { currencyCode: "RUB", currencySymbol: "₽", currencyName: "Russian Ruble", code: "RUB", symbol: "₽", name: "Russian Ruble" },
  { currencyCode: "TRY", currencySymbol: "₺", currencyName: "Turkish Lira", code: "TRY", symbol: "₺", name: "Turkish Lira" },
  { currencyCode: "EGP", currencySymbol: "E£", currencyName: "Egyptian Pound", code: "EGP", symbol: "E£", name: "Egyptian Pound" },
  { currencyCode: "NGN", currencySymbol: "₦", currencyName: "Nigerian Naira", code: "NGN", symbol: "₦", name: "Nigerian Naira" },
  { currencyCode: "PKR", currencySymbol: "PKR", currencyName: "Pakistani Rupee", code: "PKR", symbol: "PKR", name: "Pakistani Rupee" },
  { currencyCode: "BDT", currencySymbol: "৳", currencyName: "Bangladeshi Taka", code: "BDT", symbol: "৳", name: "Bangladeshi Taka" },
  { currencyCode: "LKR", currencySymbol: "Rs", currencyName: "Sri Lankan Rupee", code: "LKR", symbol: "Rs", name: "Sri Lankan Rupee" },
  { currencyCode: "NPR", currencySymbol: "Rs", currencyName: "Nepalese Rupee", code: "NPR", symbol: "Rs", name: "Nepalese Rupee" },
  { currencyCode: "KES", currencySymbol: "KSh", currencyName: "Kenyan Shilling", code: "KES", symbol: "KSh", name: "Kenyan Shilling" },
  { currencyCode: "GHS", currencySymbol: "GH₵", currencyName: "Ghanaian Cedi", code: "GHS", symbol: "GH₵", name: "Ghanaian Cedi" },
  { currencyCode: "HKD", currencySymbol: "HK$", currencyName: "Hong Kong Dollar", code: "HKD", symbol: "HK$", name: "Hong Kong Dollar" },
  { currencyCode: "KRW", currencySymbol: "₩", currencyName: "South Korean Won", code: "KRW", symbol: "₩", name: "South Korean Won" },
  { currencyCode: "MXN", currencySymbol: "Mex$", currencyName: "Mexican Peso", code: "MXN", symbol: "Mex$", name: "Mexican Peso" },
  { currencyCode: "SEK", currencySymbol: "kr", currencyName: "Swedish Krona", code: "SEK", symbol: "kr", name: "Swedish Krona" },
  { currencyCode: "NOK", currencySymbol: "kr", currencyName: "Norwegian Krone", code: "NOK", symbol: "kr", name: "Norwegian Krone" },
  { currencyCode: "DKK", currencySymbol: "kr", currencyName: "Danish Krone", code: "DKK", symbol: "kr", name: "Danish Krone" },
  { currencyCode: "PLN", currencySymbol: "zł", currencyName: "Polish Zloty", code: "PLN", symbol: "zł", name: "Polish Zloty" },
  { currencyCode: "ILS", currencySymbol: "₪", currencyName: "Israeli New Shekel", code: "ILS", symbol: "₪", name: "Israeli New Shekel" },
];

/**
 * Key-value mapping of Currency Code -> Currency Symbol
 */
export const CURRENCY_MAP = CURRENCY_LIST.reduce((acc, curr) => {
  acc[curr.currencyCode] = curr.currencySymbol;
  return acc;
}, {});

/**
 * Returns the list of all currencies and their symbols.
 * Each entry contains: currencyCode, currencySymbol, currencyName (and aliases code, symbol, name).
 *
 * @returns {Array<Object>} List of currency items.
 */
export const getCurrencyList = () => {
  return CURRENCY_LIST;
};

/**
 * Alias for getCurrencyList
 */
export const getCurrencies = () => {
  return CURRENCY_LIST;
};

/**
 * Alias for getCurrencyList
 */
export const getCurrencySymbolList = () => {
  return CURRENCY_LIST;
};

/**
 * Retrieves the symbol for a given currency code.
 * If not recognized, returns the currencyCode itself or the provided fallback.
 *
 * @param {string} currencyCode - 3-letter currency code (e.g. "AED", "INR", "USD").
 * @param {string} [fallback="₹"] - Fallback symbol if not found.
 * @returns {string} Currency symbol.
 */
export const getCurrencySymbol = (currencyCode, fallback = "₹") => {
  if (!currencyCode) {
    return localStorage.getItem("currencySymbol") || fallback;
  }
  const upperCode = String(currencyCode).trim().toUpperCase();
  if (CURRENCY_MAP[upperCode]) {
    return CURRENCY_MAP[upperCode];
  }
  const found = CURRENCY_LIST.find(
    (c) => c.currencyCode.toUpperCase() === upperCode || c.code.toUpperCase() === upperCode
  );
  if (found) {
    return found.currencySymbol;
  }
  return currencyCode || fallback;
};

/**
 * Retrieves currency details by code.
 *
 * @param {string} currencyCode - e.g. "AED"
 * @returns {Object|null}
 */
export const getCurrencyDetails = (currencyCode) => {
  if (!currencyCode) return null;
  const upperCode = String(currencyCode).trim().toUpperCase();
  return (
    CURRENCY_LIST.find(
      (c) => c.currencyCode.toUpperCase() === upperCode || c.code.toUpperCase() === upperCode
    ) || null
  );
};

/**
 * Reads the current store currency code and symbol from localStorage.
 * Defaults to INR and ₹ if not found.
 *
 * @returns {{ currencyCode: string, currencySymbol: string }}
 */
export const getStoreCurrency = () => {
  const code = localStorage.getItem("currencyCode");
  const symbol = localStorage.getItem("currencySymbol");
  const fallbackCode = "INR";
  const fallbackSymbol = "₹";

  const currencyCode = code || fallbackCode;
  const currencySymbol = symbol || (code ? getCurrencySymbol(code) : fallbackSymbol);

  return { currencyCode, currencySymbol };
};

/**
 * Retrieves the current store currency symbol from localStorage with fallback.
 *
 * @returns {string}
 */
export const getStoreCurrencySymbol = () => {
  const { currencySymbol } = getStoreCurrency();
  return currencySymbol;
};

/**
 * Retrieves the current store currency code from localStorage with fallback.
 *
 * @returns {string}
 */
export const getStoreCurrencyCode = () => {
  const { currencyCode } = getStoreCurrency();
  return currencyCode;
};

/**
 * Helper to persist currency code and symbol to localStorage.
 *
 * @param {string} currencyCode
 * @param {string} currencySymbol
 */
export const setStoreCurrency = (currencyCode, currencySymbol) => {
  if (currencyCode) {
    localStorage.setItem("currencyCode", currencyCode);
  }
  if (currencySymbol) {
    localStorage.setItem("currencySymbol", currencySymbol);
  } else if (currencyCode) {
    localStorage.setItem("currencySymbol", getCurrencySymbol(currencyCode));
  }
};
